import { render, staticRenderFns } from "./SalesOrderTable.vue?vue&type=template&id=627f47ee&scoped=true"
import script from "./SalesOrderTable.vue?vue&type=script&lang=ts"
export * from "./SalesOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./SalesOrderTable.vue?vue&type=style&index=0&id=627f47ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f47ee",
  null
  
)

export default component.exports